import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cf3439a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-900 hidden md:block py-4" }, "Outstanding Work", -1));
const _hoisted_2 = { class: "table-border-padding" };
const _hoisted_3 = { class: "border rounded-lg min-w-[900px]" };
const _hoisted_4 = { class: "min-w-full text-center text-sm" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", { class: "divide-x divide-gray-200" }, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            rowspan: "2",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                        Employee Email\n                    "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                        Outstanding Offers\n                    "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                        Outstanding Amends\n                    "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                        Outstanding Leavers\n                    ")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("tr", { class: "divide-x border-b divide-gray-200" }, [
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 border-l bg-green-100 bg-opacity-50" }, "1"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" }, "2"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" }, "3"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" }, "4"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" }, "5+"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap py-2 px-2" }, "Total"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" }, "1"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" }, "2"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" }, "3"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" }, "4"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" }, "5+"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap py-2 px-2" }, "Total"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" }, "1"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" }, "2"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" }, "3"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" }, "4"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" }, "5+"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "whitespace-nowrap py-2 px-2" }, "Total")
    ])
], -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", { class: "border-b" }, [
    /*#__PURE__*/ _createElementVNode("td", { class: "py-1" })
], -1));
const _hoisted_7 = {
    colspan: "6",
    class: "font-light"
};
const _hoisted_8 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_9 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_10 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_11 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_12 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_13 = { class: "whitespace-nowrap py-2" };
const _hoisted_14 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_15 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_16 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_17 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_18 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_19 = { class: "whitespace-nowrap py-2" };
const _hoisted_20 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_21 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_22 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_23 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_24 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_25 = { class: "whitespace-nowrap py-2" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", { class: "border-b" }, [
    /*#__PURE__*/ _createElementVNode("td", { class: "py-1" })
], -1));
const _hoisted_27 = { class: "divide-x divide-y divide-gray-200" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "font-normal"
}, [
    /*#__PURE__*/ _createElementVNode("a", { href: "#" }, "Totals")
], -1));
const _hoisted_29 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_30 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_31 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_32 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_33 = { class: "whitespace-nowrap font-bold px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_34 = { class: "whitespace-nowrap font-bold py-2" };
const _hoisted_35 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_36 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_37 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_38 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_39 = { class: "whitespace-nowrap font-bold px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_40 = { class: "whitespace-nowrap font-bold py-2" };
const _hoisted_41 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_42 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_43 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_44 = { class: "whitespace-nowrap font-bold px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_45 = { class: "whitespace-nowrap font-bold px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_46 = { class: "whitespace-nowrap font-bold py-2" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'OutstandingWork',
    props: {
        users: {}
    },
    setup(__props) {
        const props = __props;
        const sum = (data = []) => {
            return (data?.reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
            }, 0) ?? 0);
        };
        const totals = (sla = 1, type = 'OFFER') => {
            let total = 0;
            for (const user of Object.keys(props.users)) {
                total += props.users[user][type][sla];
            }
            return total;
        };
        const overallTotals = (type = 'OFFER') => {
            let total = 0;
            for (const user of Object.keys(props.users)) {
                total += sum(props.users[user][type]);
            }
            return total;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createTextVNode(),
                _createElementVNode("section", null, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("table", _hoisted_4, [
                                _hoisted_5,
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    _hoisted_6,
                                    _createTextVNode(),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.users), (user, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: index,
                                            class: "divide-x divide-y border-b divide-gray-200"
                                        }, [
                                            _createElementVNode("td", _hoisted_7, [
                                                _createElementVNode("p", null, _toDisplayString(user), 1)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.users[user].OFFER[1]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.users[user].OFFER[2]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.users[user].OFFER[3]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.users[user].OFFER[4]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.users[user].OFFER[5]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_13, _toDisplayString(sum(_ctx.users[user].OFFER)), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.users[user].AMEND[1]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.users[user].AMEND[2]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.users[user].AMEND[3]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.users[user].AMEND[4]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.users[user].AMEND[5]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_19, _toDisplayString(sum(_ctx.users[user].AMEND)), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.users[user].LEAVER[1]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.users[user].LEAVER[2]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.users[user].LEAVER[3]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.users[user].LEAVER[4]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.users[user].LEAVER[5]), 1),
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_25, _toDisplayString(sum(_ctx.users[user].LEAVER)), 1)
                                        ]));
                                    }), 128)),
                                    _createTextVNode(),
                                    _hoisted_26,
                                    _createTextVNode(),
                                    _createElementVNode("tr", _hoisted_27, [
                                        _hoisted_28,
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_29, _toDisplayString(totals(1, 'OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_30, _toDisplayString(totals(2, 'OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(totals(3, 'OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_32, _toDisplayString(totals(4, 'OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_33, _toDisplayString(totals(5, 'OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_34, _toDisplayString(overallTotals('OFFER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_35, _toDisplayString(totals(1, 'AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_36, _toDisplayString(totals(2, 'AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_37, _toDisplayString(totals(3, 'AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_38, _toDisplayString(totals(4, 'AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_39, _toDisplayString(totals(5, 'AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_40, _toDisplayString(overallTotals('AMEND')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_41, _toDisplayString(totals(1, 'LEAVER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_42, _toDisplayString(totals(2, 'LEAVER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_43, _toDisplayString(totals(3, 'LEAVER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_44, _toDisplayString(totals(4, 'LEAVER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_45, _toDisplayString(totals(5, 'LEAVER')), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_46, _toDisplayString(overallTotals('LEAVER')), 1)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
